import React from 'react'
import styled from 'styled-components'
import { Grid, H, Wrapper } from '@farewill/ui'
import { COLOR } from '@farewill/ui/tokens'

import VerticalQuote from 'components/CustomerQuote/VerticalQuote'
import { CUSTOMER_QUOTE_ID } from 'components/CustomerQuote'

const StyledVerticalQuote = styled(VerticalQuote)`
  background-color: ${COLOR.WHITE};
  height: 100%;
`

const WhyFamilies = (): React.ReactElement => (
  <Wrapper container>
    <H tag="h2" size="L" decorative centered margin={[0, 0, 'XL', 0]}>
      Why families are choosing Farewill
    </H>
    <Grid gapFromL="XL">
      <Grid.Item spanFromM={5} startColumnFromM={2}>
        <StyledVerticalQuote
          id={CUSTOMER_QUOTE_ID.ABI_CREMATION}
          decorative={false}
        />
      </Grid.Item>
      <Grid.Item spanFromM={5}>
        <StyledVerticalQuote
          id={CUSTOMER_QUOTE_ID.FRANKIE_CREMATION}
          decorative={false}
        />
      </Grid.Item>
    </Grid>
  </Wrapper>
)

export default WhyFamilies
